export default __webpack_public_path__ + "static/media/line-right.453ff120.png";